import React, { useEffect } from "react";
import { Button, DrawerBody, makeStyles, Popover, PopoverSurface, PopoverTrigger } from "@fluentui/react-components";
import PropTypes from "prop-types";
import { ReactComponent as EnterOnVR } from "../icons/EnterOnVR.svg";
import { Dismiss20Regular } from "@fluentui/react-icons";
import { useParticipantLayoutActive } from "../layout/participant-layout/ParticipantLayoutContext";
import useBreakpoints from "../hooks/useBreakpoints";
import { ResponsiveOverlayDrawer } from "../drawer/ResponsiveOverlayDrawer";

const useStyles = makeStyles({
  root: {
    height: "40px",
    minWidth: "40px",
    backgroundColor: "var(--toolbar-overlay-background)",
    "@media (min-width: 992px)": {
      position: "fixed",
      bottom: "20px",
      right: "30px"
    },
    "& span": {
      width: "24px",
      height: "24px",
      fontSize: "24px"
    },
    "& svg": {
      color: "var(--colorNeutralForeground1)",
      fill: "currentColor"
    }
  },
  enterOnVRPopover: {
    width: "300px"
  },
  enterOnVRDrawerContent: {
    width: "100%"
  }
});

export function EnterOnVRPopover({ children, open, onOpen, onClose }) {
  const classes = useStyles();
  const participantLayoutActive = useParticipantLayoutActive();
  const breakpoint = useBreakpoints();
  const isMobile = ["xs", "sm"].includes(breakpoint);

  useEffect(() => {
    if (participantLayoutActive && open) {
      onClose?.();
    }
  }, [onClose, open, participantLayoutActive]);

  const handleOpenChange = (_, { open }) => {
    open ? onOpen() : onClose();
  };

  if (participantLayoutActive) {
    return null;
  }

  if (isMobile) {
    return (
      <>
        <Button className={classes.root} appearance="subtle" icon={<EnterOnVR />} onClick={onOpen} />
        <ResponsiveOverlayDrawer desktopPosition="end" size="full" open={open}>
          <DrawerBody style={{ padding: "40px 30px" }}>
            <div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
              <Button style={{ maxHeight: "32px" }} appearance="subtle" icon={<Dismiss20Regular />} onClick={onClose} />
            </div>
            <div className={classes.enterOnVRDrawerContent}>{children}</div>
          </DrawerBody>
        </ResponsiveOverlayDrawer>
      </>
    );
  }

  return (
    <Popover open={open} positioning={"above-start"} withArrow onOpenChange={handleOpenChange}>
      <PopoverTrigger disableButtonEnhancement>
        <Button className={classes.root} appearance="subtle" icon={<EnterOnVR />} />
      </PopoverTrigger>
      <PopoverSurface tabIndex={-1}>
        <div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
          <Button style={{ maxHeight: "32px" }} appearance="subtle" icon={<Dismiss20Regular />} onClick={onClose} />
        </div>
        <div className={classes.enterOnVRPopover}>{children}</div>
      </PopoverSurface>
    </Popover>
  );
}

EnterOnVRPopover.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};
